import { useMutation } from '@tanstack/react-query'
import api from '@/lib/api'
import { useAccessToken } from '@/features/auth/state/auth'

export function useUpdatePDFAgreement() {
  const token = useAccessToken()
  return useMutation({
    mutationFn: async ({ id, minuta }: { id: string; minuta: File }) => {
      if (!token) throw new Error('Token está ausente')
      if (!minuta) throw new Error('Arquivo de minuta é obrigatório')
      const formData = new FormData()
      formData.append('minuta', minuta)
      const { data } = await api.post(`/agreement/update-PDF/${id}`, formData, {
        headers: { Authorization: `Bearer ${token}` } // deixe o Content-Type para o Axios definir o boundary
      })
      if (!data) throw new Error('Erro ao atualizar a minuta (PDF)')
      return data
    }
  })
}
